import { render, staticRenderFns } from "./IndustrialMtrDetail.vue?vue&type=template&id=147d3246&scoped=true"
import script from "./IndustrialMtrDetail.vue?vue&type=script&lang=js"
export * from "./IndustrialMtrDetail.vue?vue&type=script&lang=js"
import style0 from "./IndustrialMtrDetail.vue?vue&type=style&index=0&id=147d3246&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d3246",
  null
  
)

export default component.exports